import * as React from 'react';
import { StarryUIIcon } from '../components/StarryUIIcon';

export const ChevronStepRight = ({ color = 'currentColor', ...icon }: image.IStarryUIIcon) => (
    <StarryUIIcon {...icon}>
        <path
            d="M13.6667 12.0666C13.6615 12.2119 13.5968 12.3559 13.4723 12.4669L8.13448 17.2262C7.87546 17.4578 7.4546 17.4578 7.19483 17.2262C6.93506 16.9953 6.93506 16.6201 7.19483 16.3884L12.042 12.0666L7.19483 7.74482C6.93506 7.51318 6.93506 7.13795 7.19483 6.90701C7.4546 6.67537 7.87544 6.67537 8.13448 6.90701L13.4723 11.6663C13.5968 11.7773 13.6615 11.9213 13.6667 12.0666Z"
            fill={color}
        />
        <rect x="16.3335" y="17.3666" width="1" height="10.7" rx="0.5" transform="rotate(-180 16.3335 17.3666)" fill={color} />
    </StarryUIIcon>
);
